/* any functionality that's shared between component variants but not needed by external components goes in this file */
import React from 'react';
import { FauxInputCheck, FauxInputContainer, Group, StyledSVG } from './styles';
export var FauxInput = function FauxInput(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    "aria-hidden": true,
    role: "presentation",
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    size: size
  }, /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(FauxInputContainer, {
    x: 1,
    y: 1,
    height: 22,
    width: 22
  }), /*#__PURE__*/React.createElement(FauxInputCheck, {
    d: "M15.2087583,14.786627 L15.2087583,15.6008932 C15.2087583,16.1526016 14.7608475,16.5998497 14.2081037,16.5998497 L9.9812967,16.5998497 C9.42865041,16.5998497 8.98064208,16.1571894 8.98064208,15.6008932 L8.98064208,14.5988063 C8.98064208,14.0470978 9.42855284,13.5998497 9.9812967,13.5998497 L12.2087583,13.5998497 L12.2087583,6.58484723 C12.2087583,6.03516009 12.6514186,5.58955062 13.2077148,5.58955062 L14.2098017,5.58955062 C14.7615102,5.58955062 15.2087583,6.03557457 15.2087583,6.58484723 L15.2087583,14.786627 Z",
    transform: "translate(12.0947, 11.0947) rotate(-315) translate(-12.0947, -11.0947)"
  })));
};